/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useRef } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { MembersMenu } from '../../TaskMenus/MembersMenu';
import { ITaskMembersProps } from './types';
import { UserImg } from './UserImg';
import { UserImgWithDelete } from './UserImgWithDelete';
import { updateTaskSimple } from '../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { ITaskSimple } from '../../../../../../../../app/resource/task-simple/task-simple.types';

export const TaskMembers: FunctionComponent<ITaskMembersProps> = ({ userIds, taskId }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskMembers');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskMembers'));
    }
  }, [dispatch, open]);

  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');

  return (
    <div className="col">
      <h5 className="bold">MEMBERS</h5>
      <div className="users py-1 flex aic">
        {task && <TaskMembersAvatarList task={task} />}
        <div className={open ? 'dropdown opened' : 'dropdown'}>
          <a
            className="small-avatar gray-bg blueGray bold mr-05 flex aic jcc dropdown-button"
            onClick={toggle}
            ref={triggerRef}
          >
            <i className="icon-plus" />
          </a>
          {open && (
            <MembersMenu
              userIds={userIds}
              dropRight={false}
              closeMenu={toggle}
              taskId={task?.id}
              triggerRef={triggerRef}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const TaskMembersAvatarList: FunctionComponent<{ task: ITaskSimple }> = ({ task }) => {
  const dispatch = useDispatch();

  const isActionItem = task?.showInTasks === '1';
  const onlyOneUserAssigned = task?.members.length === 1;
  const allowedToFastDelete = (isActionItem && !onlyOneUserAssigned) || !isActionItem;

  const handleDelete = useCallback(
    (userId: string) => {
      if (task && userId) {
        const updatedTask = {
          id: task.id,
          title: task.title,
          description: task.description,
          dueDate: task.dueDate,
          userId: task.userId,
          meetingIds: task.meetingIds,
          status: task.status,
          label: task?.labels ? task.labels : [],
          taskTypeId: task.taskTypeId,
          members: task.members.filter((taskMember) => taskMember !== userId),
          showInTasks: task.showInTasks,
          boardId: task.boardId,
        };
        dispatch(updateTaskSimple(updatedTask.id, updatedTask));
      }
    },
    [dispatch, task],
  );
  return (
    <>
      {allowedToFastDelete
        ? task?.members.map((taskUserId) => (
            <UserImgWithDelete
              key={`memberId-${taskUserId}`}
              userId={taskUserId}
              onDelete={() => handleDelete(taskUserId)}
            />
          ))
        : task?.members.map((taskUserId) => <UserImg key={`memberId-${taskUserId}`} userId={taskUserId} />)}
    </>
  );
};
